"use strict"

/**
 * @enum FileGasProjectType
 */
let FileGasProjectType
;(function (fileGasProjectType) {
  fileGasProjectType.None = 0
  fileGasProjectType[0] = "None"
  fileGasProjectType.IdCard = 1
  fileGasProjectType[1] = "IdCard"
  fileGasProjectType.FirstPlan = 2
  fileGasProjectType[2] = "FirstPlan"
  fileGasProjectType.MapFront = 3
  fileGasProjectType[3] = "MapFront"
  fileGasProjectType.BackFront = 4
  fileGasProjectType[4] = "BackFront"
  fileGasProjectType.MapFrontAssign = 5
  fileGasProjectType[5] = "MapFrontAssign"
  fileGasProjectType.BackFrontAssign = 6
  fileGasProjectType[6] = "BackFrontAssign"
  fileGasProjectType.Consent = 7
  fileGasProjectType[7] = "Consent"
  fileGasProjectType.RelatedPermit = 8
  fileGasProjectType[8] = "RelatedPermit"
  fileGasProjectType.EstimationSheet = 9
  fileGasProjectType[9] = "EstimationSheet"
  fileGasProjectType.ApprovedPostalCode = 14
  fileGasProjectType[14] = "ApprovedPostalCode"
  fileGasProjectType.Other = 30
  fileGasProjectType[30] = "Other"
})(FileGasProjectType || (FileGasProjectType = {}))

export { FileGasProjectType }
